import { createProvider } from '@/vue-apollo';
import VueApollo from 'vue-apollo';
import Vue from 'vue';

Vue.use(VueApollo);

const vueInstance = new Vue({
  apolloProvider: createProvider(),
});

export default class Query
{
  constructor () {
    this.error = false;
    this.loading = false;
    this.success = false;
  }

  query (query, variables = {}) {
    this.error = false;
    this.loading = true;
    this.success = false;

    return new Promise((resolve, reject) => {
      vueInstance.$apollo.query({
        query,
        variables,
      })
        .then(response => {
          this.onSuccess(response);

          resolve(response);
        })
        .catch(response => {
          this.onError(response);

          reject(response);
        })
        .finally(() => {
          this.onFinally();
        });
    })
  }

  onSuccess () {
    this.success = true;
  }

  onError () {
    this.error = true;
  }

  onFinally () {
    this.loading = false;
  }

  reset () {
    this.error = false;
    this.loading = false;
    this.success = false;
  }
}
